import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is App Store Optimization, and why is it crucial for app growth?",
    answer: `<p>App Store Optimization (ASO) enhances your app’s visibility in stores, driving organic downloads and discoverability.</p>`,
  },
  {
    question: "How does your app store optimization agency determine the right keywords?",
    answer: `<p>Our App Store Optimization agency uses data-driven tools to analyze search trends, competition, and user behavior to identify high-impact keywords.</p>`,
  },
  {
    question: "What role does A/B testing play in app store optimization services?",
    answer: `<p>A/B testing in ASO helps experiment with metadata and visuals to identify the most effective combinations for boosting conversions.</p>`,
  },
  {
    question:
      "How often should app store optimization be updated?",
    answer: `<p>ASO should be regularly updated based on performance data, algorithm changes, and market trends to maintain app visibility.</p>`,
  },
  {
    question: "Can app store optimization services help with app user retention?",
    answer: `<p>Yes, ASO services attract the right users by optimizing relevant keywords and improving user experience, which boosts retention.</p>`,
  },
  {
    question: "How does your app store optimization agency measure the success of an ASO campaign?",
    answer: `<p>Our ASO agency tracks metrics like keyword rankings, conversion rates, and organic downloads to evaluate campaign effectiveness.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>ASO Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
